import React, {useState} from 'react'
import {graphql} from 'gatsby'
import Link from '../Link/Link'
import './Tiles.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Icon from './Icon'
import EmbedContainer from '../EmbedContainer/EmbedContainer'
import PlaySymbol from '../../assets/svg/play.inline.svg'

const Tile = ({icon, image, imagetype, text, title, movieEmbed, moviePlayText, newslabel}) => {

	const [videoActive, setVideoActive] = useState(false)

	return(
		<div className="Tile">
			<div className="image">
				{
					imagetype === 'icon'
					? <Icon icon={icon} />
					: <div className="image-normal"><GatsbyImage image={getImage(image.localFile.childImageSharp)} /></div>
				}
			</div>
			<div className="content">
				{ title ? <h2 className={newslabel ? 'title news' : 'title'} dangerouslySetInnerHTML={{__html: title}} /> : null }
				{ text ? <div className="text" dangerouslySetInnerHTML={{__html: text}} /> : null }
				{
					movieEmbed &&
					<div className="movie">
						<button aria-expanded={videoActive} onClick={ () => setVideoActive(true)}>
							<PlaySymbol />
							{moviePlayText ? moviePlayText : 'Se hjelpefilm'}
						</button>
						{
							videoActive &&
							<EmbedContainer embed={movieEmbed} close={() => setVideoActive(false)} />
						}
					</div>
				}
			</div>
		</div>
	)
}

export default function Tiles({items, id, link, centered, gap}) {
	return(
		<div className={`Tiles ${centered ? 'centered' : ''}`}>
			<div className="items" style={gap && {gap: gap}}>
				{
					items.map((tile, i) => <Tile key={`${id}_${i}`} {...tile} />)
				}
			</div>
			{
				link &&
				<div className="Tiles-link">
					<Link type="arrow" color="primary" {...link} />
				</div>
			}
		</div>
	)
}

export const query = graphql`
	fragment Tiles on WpPage_Layout_block_Layout_Tiles {
		fieldGroupName
		centered
		gap
		link {
			url
			title
			target
		}
		items {
			icon
			imagetype
			text
			title
			movieEmbed
			moviePlayText
			newslabel
			image {
				altText
				altText
				localFile {
					childImageSharp {
						fluid(maxWidth: 300, quality: 70) {
							...GatsbyImageSharpFluid
						}
					}
				}
			}
		}
	}
`